import React from "react";
import { Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";

const NavTabEmployee = ({ loading, toggleTab, activeTab, countByStatus }) => {
  return (
    <Nav
      className="nav-tabs-custom p-1 px-2 mb-1 card-header-tabs border-bottom-0 mt-0 "
      role="tablist"
    >
      <NavItem>
        <NavLink
          className={classnames(
            {
              active: activeTab === "1",
              disabled: loading,
              "fw-semibold": activeTab === "1",
            },
            " text-primary d-flex align-items-center"
          )}
          onClick={(e) => {
            if (loading) {
              e.preventDefault();
            } else {
              toggleTab("1", "current");
            }
          }}
          href="#"
        >
          ACTIVE
          {countByStatus?.active && countByStatus?.active !== 0 ? (
            <span className="badge badge-soft-success align-middle rounded-pill ms-1">
              {countByStatus.active}
            </span>
          ) : null}
        </NavLink>
      </NavItem>

      <NavItem className="mx-3">
        <NavLink
          className={classnames(
            {
              active: activeTab === "3",
              disabled: loading,
              "fw-semibold": activeTab === "3",
            },
            " text-primary d-flex align-items-center"
          )}
          onClick={(e) => {
            if (loading) {
              e.preventDefault();
            } else {
              toggleTab("3", "pending");
            }
          }}
          href="#"
        >
          PENDING
          {countByStatus?.pending && countByStatus?.pending !== 0 ? (
            <span className="badge badge-soft-warning  align-middle rounded-pill ms-1">
              {countByStatus.pending}
            </span>
          ) : null}
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink
          className={classnames(
            {
              active: activeTab === "2",
              disabled: loading,
              "fw-semibold": activeTab === "2",
            },
            " text-primary d-flex align-items-center"
          )}
          onClick={(e) => {
            if (loading) {
              e.preventDefault();
            } else {
              toggleTab("2", "terminated");
            }
          }}
          href="#"
        >
          TERMINATED
          {countByStatus?.terminated && countByStatus?.terminated !== 0 ? (
            <span className="badge badge-soft-danger align-middle rounded-pill ms-1">
              {countByStatus.terminated}
            </span>
          ) : null}
        </NavLink>
      </NavItem>
    </Nav>
  );
};

export default NavTabEmployee;
